import React from 'react'
import {Link} from "react-router-dom"
import "./Rescuer.css"

export default function Rescuer(props) {

    const {rescuer, onClick} = props
    const className = props.className || ""
    
    const getInfo = () => {
        let info = ""
        if (rescuer.nickname)
            info = rescuer.nickname + " "
        info += rescuer.username
        if (!!rescuer.gss_id && rescuer.username !== rescuer.gss_id)
            info += " (" + rescuer.gss_id + ")"
        return info
    }
    
    if (!rescuer) return

    const body = <>
        {rescuer.thumbnail && rescuer.thumbnail.startsWith("https://")
            ? <div className="rescuer-initials" style={{backgroundImage: `url(${rescuer.thumbnail})`}}></div>
            : <div className="rescuer-initials">{rescuer.initials}</div>
        }
        <div className="rescuer-data">
            <div className="rescuer-name" title={`${rescuer.given_name} ${rescuer.family_name}`}>{rescuer.given_name} {rescuer.family_name}</div>
            <div className="rescuer-info">{getInfo()}</div>
        </div>
    </>

    // With action buttons the chip itself is not a button: the body links to the profile, the actions sit on the right
    if (props.actions) {
        return <div className={`rescuer has-actions ${className}`} data-username={rescuer.username}>
            {onClick === 'profile'
                ? <Link className="rescuer-main" to={`/rescuer/${rescuer.username}`}>{body}</Link>
                : <div className="rescuer-main">{body}</div>
            }
            <div className="rescuer-actions">{props.actions}</div>
        </div>
    }

    let resc = <div className={`rescuer ${className}`} data-username={rescuer.username}>{body}</div>

    if (onClick === 'profile') {
        resc = <Link to={`/rescuer/${rescuer.username}`}>{resc}</Link>
    }
    else if (onClick) {
        resc = <button className='rescuer' onClick={event => onClick(rescuer)}>{resc}</button>
    }

    return resc

}
